import React from "react";

const NoSidebarLayout = ({ children, islogin }) => {
  return (
    <div className="min-vh-80">
      <div className="main-content" style={{ width: "100%", marginLeft: 0 }}>
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, { islogin })
            : child
        )}
      </div>
    </div>
  );
};

export default NoSidebarLayout;
